import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setOriginCertificateList: [],
    setOriginCertificateFilter: [],
    cleanOriginCertificateList: [],
    setNewFileDetails: [],
    setOriginCertificateFile: [],
    setOriginCertificateData: [],
    setIsLoadingOriginCertificate: [],
    setOriginCertificateToast: []
});
 
/**
 * Handlers
 */
const INITIAL_STATE = {
    isLoadingList: false,    
    originCertificateList: [],
    page: 1,
    hasMore: true,
    isLoading: false,
    toast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
    filter: {
		codigo: '',
        pedido: '',
        dtPedidoInicial: '',
        dtPedidoFinal: '',
        dtAtualizacaoInicial: '',
        dtAtualizacaoFinal: '',
	},
    fileDetails: {},
    file: undefined
};

const setOriginCertificateList = (state = INITIAL_STATE, action) => {
    return { 
        ...state, 
        originCertificateList: state.originCertificateList.concat(action.payload.list),
        page: action.payload.page,
        hasMore: action.payload.hasMore
    };
}

const setOriginCertificateFilter = (state = INITIAL_STATE, action) => {
    return { ...state, filter: action.payload };
}

const cleanOriginCertificateList = (state = INITIAL_STATE, action) => {
    return { ...state, originCertificateList: [] };
}

const setNewFileDetails = (state = INITIAL_STATE, action) => {
    return { ...state, fileDetails: action.payload };
}

const setOriginCertificateFile = (state = INITIAL_STATE, action) => {
    return { ...state, file: action.payload };
}

const setOriginCertificateData = (state = INITIAL_STATE, action) => {
    return { ...state, fileDetails: action.payload };
}

const setIsLoadingOriginCertificate = (state = INITIAL_STATE, action) => {
    return { ...state, isLoading: action.payload };
}

const setOriginCertificateToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        toast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}


/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ORIGIN_CERTIFICATE_LIST]: setOriginCertificateList,
    [Types.SET_ORIGIN_CERTIFICATE_FILTER]: setOriginCertificateFilter,
    [Types.CLEAN_ORIGIN_CERTIFICATE_LIST]: cleanOriginCertificateList,
    [Types.SET_NEW_FILE_DETAILS]: setNewFileDetails,
    [Types.SET_ORIGIN_CERTIFICATE_FILE]: setOriginCertificateFile, 
    [Types.SET_ORIGIN_CERTIFICATE_DATA]: setOriginCertificateData,
    [Types.SET_IS_LOADING_ORIGIN_CERTIFICATE]: setIsLoadingOriginCertificate,
    [Types.SET_ORIGIN_CERTIFICATE_TOAST]: setOriginCertificateToast,
});
 